export default {
  name: 'BLANK',
};



// WEBPACK FOOTER //
// ./src/editors/BlankEditor/config.js